import {useInfiniteQuery, useQuery, UseQueryResult} from "@tanstack/react-query";
import axiosAuthorised from "./AxiosAuthorised";
import {AccountOverviewType} from "../Types/Response/AccountOverview";
import {DashboardOverviewType} from "../Types/Response/DashboardOverview";
import {PaginatedResponseType} from "../Types/Response/PaginatedResponseType";
import { PaginationPageParameters } from "./PaginationHelpers";

/*const useClientLimitedEvents = () => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/Mobile/v1/User/LimitedEvents?offset=0&limit=20`;

    return useInfiniteQuery(
        ['userActivity'],
        async ({ pageParam = baseUrl }) => {
            const {data} : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam);
            return data;
        },
        {
            getPreviousPageParam: (firstPage) => firstPage.links.previous ? `${process.env.REACT_APP_API_HOST}${firstPage.links.previous}` : null,
            getNextPageParam: (lastPage) => lastPage.links.next ? `${process.env.REACT_APP_API_HOST}${lastPage.links.next}` : null,
            staleTime: 600000,
        },
    );
}*/

const useClientLimitedEvents = () => {
    return useQuery(["limitedEvents"], async () => {
            const { data } : { data: any } = await axiosAuthorised.get(`${process.env.REACT_APP_API_HOST}/Mobile/v1/User/LimitedEvents`);
            return data;
        },
        {
            staleTime: 600000,
        });
}

const useClientAccountOverview = () => {
    return useQuery(["userInfo"], async () => {
        const { data } : { data: AccountOverviewType } = await axiosAuthorised.get(`${process.env.REACT_APP_API_HOST}/Mobile/v1/User/AccountOverview`);

        return data;
    },
    {
        staleTime: 600000,
    });
}

const useClientDashboard = () : UseQueryResult<DashboardOverviewType, Error> => {
    return useQuery(["userDashboard"], async () => {
        const { data } = await axiosAuthorised.get(`${process.env.REACT_APP_API_HOST}/Mobile/v1/User/Dashboard`);

        return data;
    },
    {
        staleTime: 600000,
    });
}

const useInfiniteClientActivity = () => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/Mobile/v1/user/ActivityFeed?offset=0&limit=20`;

    return useInfiniteQuery(
        ['userActivity'],
        async ({ pageParam = baseUrl }) => {
            const {data} : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam);
            return data;
        },
        {
            ...PaginationPageParameters,
            staleTime: 600000,
        },
    );
}

const useInfiniteClientStatements = () => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/Mobile/v1/Statement/List?offset=0&limit=20`;

    return useInfiniteQuery(
        ['userStatements'],
        async ({ pageParam = baseUrl }) => {
            const {data} : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam);
            return data;
        },
        {
            ...PaginationPageParameters,
            staleTime: 600000,
        },
    );
}

const useInfiniteClientTransactions = () => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/Mobile/v1/Transaction/List?offset=0&limit=20`;

    return useInfiniteQuery(
        ['userTransactions'],
        async ({ pageParam = baseUrl }) => {
            const {data} : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam);
            return data;
        },
        {
            ...PaginationPageParameters,
            staleTime: 600000,
        },
    );
}

export { useClientAccountOverview, useClientDashboard, useClientLimitedEvents, useInfiniteClientActivity, useInfiniteClientStatements, useInfiniteClientTransactions}